module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/ru-card-drag.478c2ce37a55fc99b3de.gif";